// only verify once every 60sec
const time = Math.floor(Date.now() / 1000);
const cookieMatch = document.cookie
  .split('; ')
  .find(r => r.startsWith('t11_verify_time='));
const last_checked = cookieMatch ? cookieMatch.split('=')[1] : null;

if (last_checked && last_checked < 60 + time) {
  document.cookie = `t11_verify_time=${time}; path=/`;
  fetch(`https://${window.apiUrl}/api/account/verify`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ return_url: window.top.location.href }),
  })
    .then(r => r.json())
    .then(data => {
      if (data.success) window.location = data.redirect_to;
    });
}
